module.exports = __webpack_public_path__ + "static/media/UPI.c7ceddd7.png";